import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Grid, Table, TableHead, TableBody, TableCell, TableRow } from '@mui/material';
import { Ballot } from '@mui/icons-material';
import { Card, Autocomplete, Typography, IconButton } from '@totalsoft/rocket-ui';
import { Prompt } from 'react-router-dom';
import { isValid, getErrors } from '@totalsoft/pure-validations-react';
import { TableCellWithWidth } from 'components/list/TableComponentsStyled';

const AllowedStateReasonsEditCard = ({ reasons, documentStateReasonsList, onPropertyChanged, changed, onListChanged, validation }) => {
  const { t } = useTranslation();
  return (
    <Card
      icon={Ballot}
      iconColor='primary'
      title={t('DocumentTypes.DocumentAllowedState.Reasons')}
      actions={
        <IconButton type='add' fontSize='medium' color='transparent' title={t('Tooltips.Add')} onClick={() => onListChanged('AddItem')} />
      }
    >
      <>
        <Prompt when={changed} message={t('DocumentTypes.DocumentStateTransition.LeavingWithoutSavingDocumentAllowedState')} />
        <Grid container>
          <Grid item xs={12} sm={12} md={12}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell />
                  <TableCellWithWidth w={5} />
                </TableRow>
              </TableHead>
              <TableBody>
                {reasons.map((reason, index) => {
                  return (
                    <TableRow key={index}>
                      <TableCell>
                        <Autocomplete
                          fullWidth
                          value={reason.reasonId}
                          simpleValue
                          onChange={event => onPropertyChanged(index, 'reasonId', event)}
                          options={documentStateReasonsList}
                          error={!isValid(validation[index].reasonId)}
                          helperText={getErrors(validation[index].reasonId)}
                          isSearchable={true}
                        />
                      </TableCell>
                      <TableCell>
                        <IconButton
                          color='transparent'
                          type='delete'
                          tooltip={t('Tooltips.Delete')}
                          onClick={() => onListChanged('DeleteItem', index)}
                        />
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </Grid>
        </Grid>
        <Typography color='error'>{validation |> getErrors}</Typography>
      </>
    </Card>
  );
};

AllowedStateReasonsEditCard.propTypes = {
  onPropertyChanged: PropTypes.func.isRequired,
  onListChanged: PropTypes.func.isRequired,
  reasons: PropTypes.array.isRequired,
  documentStateReasonsList: PropTypes.array.isRequired,
  changed: PropTypes.bool.isRequired,
  validation: PropTypes.object.isRequired
};

export default AllowedStateReasonsEditCard;
